var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Erreur 404")]),_c('p',[_vm._v(" La page/fonction que vous recherchez n'a pas été trouvée sur cette application. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }